// Animated "bot is typing" bubble — ports ui.js showTypingIndicator.
// Shows a delayed "Думаю над ответом..." status after 4s, as the old code did.
import { useEffect, useState } from 'react'
import styles from './TypingIndicator.module.css'

export default function TypingIndicator() {
  const [showStatus, setShowStatus] = useState(false)
  useEffect(() => {
    const t = setTimeout(() => setShowStatus(true), 4000)
    return () => clearTimeout(t)
  }, [])

  return (
    <div className={styles.row}>
      <img className={styles.avatar} src="/assets/app-icon.png" alt="" />
      <div>
        <div className={styles.dots}>
          <span />
          <span />
          <span />
        </div>
        {showStatus && <div className={styles.status}>Думаю над ответом...</div>}
      </div>
    </div>
  )
}
